<template>
    <div class="optionboard-phonetic-consonant">
        <div class="optionboard-phonetic-consonant__feature-type">
            <span class="optionboard-phonetic-consonant__feature-label">DEĞİŞKE ÖZELLİĞİ</span>
            <div class="optionboard-phonetic-consonant__feature-options">
                <BtnOptionPhoneticConsonant
                    v-for="consonantVariantOption in consonantVariantOptions"
                    :optionSlug="consonantVariantOption"
                    :optionText="$t('consonant.variant.' + consonantVariantOption)"
                    @click="selectConsonantVariant(consonantVariantOption)" />
            </div>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import BtnOptionPhoneticConsonant       from '@/components/BtnOptionPhoneticConsonant.vue';


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            BtnOptionPhoneticConsonant,
        },

        props: {
            consonantVariantOptions: { type: Array, default: ['postdorsal', 'predorsal', 'fricative', 'approximant', 'voiced', 'devoiced'] },
        },

        methods: {
            selectConsonantVariant(answerDataConsonantVariant){
                this.$store.commit('setAnswerDataConsonantVariant', answerDataConsonantVariant);
            }
        }
    };
</script>

<style scoped src="@/css/components/optionboard-phonetic-consonant.css"></style>